import React, {Component} from 'react';
import {connect} from 'react-redux';
import ProductsFormComponent from "../../components/Products/ProductsFormComponent";
import {
    addingProduct,
    changeProductFormSettings, clearProduct,
    deletingProduct,
    editChangedProduct,
    editingProduct,
    editNewProduct, editOperatorGroups,
    getProductBydId,
    gettingAllProducts, setOperatorGroups,
    showingEditProductForm
} from "../../actions/products";
import {toGetCategories} from "../../actions/categories";
import _ from 'lodash';
import {push, goBack} from 'react-router-redux';
import {parseCategories, parseLogin, parseProducts} from "../../helpers/parseImmutables";
import { getBrands } from '../../actions/brands';
import parseBrands from '../../helpers/parseBrands';
import { clearRelatedProducts, setRelatedProducts, setRelatedProductsEdit } from '../../actions/relatedProducts';
import parseRelatedProducts from '../../helpers/parseRelatedProducts';
import fillInNames from '../../helpers/unileverSales/fillInNames';
import parseLabels from '../../helpers/parseLabels';
import { editProductLabel, getProductsLabels, tempNewProductAddProductLabel } from '../../actions/productLabels';
import { PDF_TYPES } from '../../helpers/constants/productAttachmentTypes';
import parseOperatorGroups from '../../helpers/parseOperatorGroups';


class ProductFormHOC extends Component {
    constructor(props) {
        super(props);
        this.state = {
            recipes: [],
            errorMessage: undefined,
            uploading: false,
        };
    }

    componentWillReceiveProps(nextProps){
        if(this.props.products.deleting && !nextProps.products.deleting && !nextProps.products.sendResponse){
            this.props.goBack();
        }
    }

    componentDidMount(){
        this.props.clearProduct();
        this.props.getAllCategories(this.props.login.userInfo.brand.id, this.props.login.userInfo.token);
        this.props.getBrands();
        this.props.getProductsLabels({
            limit: 1000,
        });
        if(this.props.location.pathname.includes('edit')){
            this.props.getProductBydId(_.last(this.props.location.pathname.split('/')), this.props.login.userInfo.token);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.location.pathname.includes('edit')
          && prevProps.fetchingProduct && !this.props.fetchingProduct){
            // transform them to state entities
            const recipes = this.props.products.changedProduct[PDF_TYPES.VIDEOS]
              .map(vid => ({
                base: undefined,
                name: vid.filename,
                type: vid.type,
                hash: vid.hash
            }));
            this.setState({
                recipes,
            });
        }
    }

    componentWillUnmount() {
        this.props.clearRelatedProducts();
    }

    handleProductSubmit = (evt) => {
        if (evt.key === "Enter" || typeof(evt.key) === "undefined") {
            evt.preventDefault();
            if (this.props.router.location.pathname.includes("add")) {
                if(!this.props.products.newProduct.cid){
                    this.props.changeStoreSettings('sendResponse', 'Please, select a category for the product.');
                    return false;
                }
                this.props.addProduct({
                      ...this.props.products.newProduct,
                      relatedProducts: this.props.relatedProductsSelected,
                      recipes: this.state.recipes,
                      token: this.props.login.userInfo.token},
                    this.props.login.userInfo.brand.id);
            }
            else if (this.props.router.location.pathname.includes("edit")) {
                if(!this.props.products.changedProduct.cid) {
                    this.props.changeStoreSettings('sendResponse', 'Please, select a category for the product.');
                    return false;
                }
                this.props.editProduct({...this.props.products.changedProduct,
                    relatedProducts: this.props.relatedProductsSelectedEdit,
                    recipes: this.state.recipes,
                    brandId:this.props.login.userInfo.brand.id}, this.props.login.userInfo.token)
            }
        }
    };

    handleTextInputChange = (evt) => {
        let name = evt.target.name;
        let value = evt.target.value;
        if (name === "points" || name === "value") {
            // value = parseFloat(value)
        }
        if (this.props.router.location.pathname.includes("add")) {
            this.props.tempNewProduct(name, value)
        }
        else if (this.props.router.location.pathname.includes("edit")) {
            this.props.tempChangedProduct(name, value)
        }
    };

    handleProductInputChange = (name, value) => {
        if (name === "points" || name === "value") {
            // value = parseFloat(value)
        }
        if (this.props.router.location.pathname.includes("add")) {
            this.props.tempNewProduct(name, value)
        }
        else if (this.props.router.location.pathname.includes("edit")) {
            this.props.tempChangedProduct(name, value)
        }
    };

    getCategoryArray = () => {
        let categoryArray = [];
        for (let index in this.props.categories.all) {
            if (this.props.categories.all[index].brid === this.props.login.userInfo.brid) {
                categoryArray.push({
                    key: this.props.categories.all[index].cid,
                    value: this.props.categories.all[index].catName
                });
            }
        }
        return categoryArray;
    };

    showProduct = (evt) => {
        this.props.showEditProductForm(this.props.products.all[evt.target.value])
    };

    handleDelete = (evt) => {
        this.props.deleteProduct(this.props.products.changedProduct.productId, this.props.login.userInfo.token);
    };

    handleImageInput = (evt) => {
        let e = evt.target.files;
        let reader = new FileReader();
        let handleChange ;
        if(this.props.router.location.pathname.includes('edit')){
            handleChange = this.props.tempChangedProduct;
        }
        else {
            handleChange =this.props.tempNewProduct;
        }
        try {
            reader.readAsText(e[0]);
            reader.onload = function () {
                let attachment = {
                    name: e[0].name,
                    type: e[0].type,
                    file: e[0]
                };
                reader.readAsDataURL(e[0]);
                reader.onload = () => {
                    attachment = {...attachment, base64: reader.result};
                    handleChange('attachment', attachment);
                    handleChange('imageName', '');
                };
                reader.onerror = (error) => {
                    console.log('Error: ', error);
                }
            };
            reader.onerror = function (error) {
                console.log('Error: ', error);
            };
        }
        catch (e) {

        }
    };

    handlePdfInput = (evt, name) => {
        let e = evt.target.files;
        let reader = new FileReader();
        let handleChange ;
        if(this.props.router.location.pathname.includes('edit')){
            handleChange = this.props.tempChangedProduct;
        }
        else {
            handleChange =this.props.tempNewProduct;
        }
        try {
            reader.readAsText(e[0]);
            reader.onload = function () {
                let attachment = {
                    name: e[0].name,
                    type: e[0].type,
                    pdfType: name,
                    file: e[0]
                };
                reader.readAsDataURL(e[0]);
                reader.onload = () => {
                    attachment = {...attachment, base64: reader.result};
                    handleChange(name, attachment);
                };
                reader.onerror = (error) => {
                    console.log('Error: ', error);
                }
            };
            reader.onerror = function (error) {
                console.log('Error: ', error);
            };
        }
        catch (e) {

        }
    };

    addRecipe = (evt) => {
        this.setState({
            errorMessage: undefined,
            uploading: true,
        });
        let e = evt.target.files;
        const sizeCheck = this.checkFileSize(evt);
        if (!sizeCheck) {
            this.setState({
                errorMessage: 'File is is too large, please pick files smaller than 50 MB',
                uploading: false,
            });
            return false;
        }
        let reader = new FileReader();
        let handleChange ;
        const scope = this;

        try {
            reader.readAsText(e[0]);
            reader.onload = function () {
                let attachment = {
                    name: e[0].name,
                    type: e[0].type,
                    file: e[0],
                    size: e[0].size,
                };
                reader.readAsDataURL(e[0]);
                reader.onload = () => {
                    attachment = {...attachment, base64: reader.result};
                    scope.setState({
                        recipes: scope.state.recipes.concat([{
                            base: reader.result,
                            name: attachment.name,
                            type: attachment.type,
                            size: attachment.size,
                        }]),
                        uploading: false,
                    });
                };
                reader.onerror = (error) => {
                    scope.setState({
                        errorMessage: error,
                        uploading: false,
                    });
                    console.log('Error: ', error);
                }
            };
            reader.onerror = function (error) {
                scope.setState({
                    errorMessage: error,
                    uploading: false,
                });
                console.log('Error: ', error);
            };
        }
        catch (e) {
            scope.setState({
                errorMessage: e,
                uploading: false,
            });
            //Show an error
        }
    };

    checkFileSize=(evt)=>{
        let files = evt.target.files;
        let size = 110077384;
        let err = "";
        for(var x = 0; x<files.length; x++) {
            console.log(files[x].size);
            if (files[x].size > size) {
                err += files[x].type+'is too large, please pick files smaller than 110 MB\n';
            }
        }
        if (err !== '') {
            evt.target.value = null;
            console.log(err);
            return false
        }
        return true;
    };

    removeAttachment = (attachmentType) => {
        let attachment = {
            name: '',
            type: '',
            file: '',
            base64: '',
        };
        if(this.props.router.location.pathname.includes('edit')){
            this.props.tempChangedProduct('attachment', attachment);
            this.props.tempChangedProduct('imageName', '');
        }
        else {
            this.props.tempNewProduct('attachment', attachment);
            this.props.tempNewProduct('imageName', '');
        }
    };

    removePdf = (pdfType) => {
        if(this.props.router.location.pathname.includes('edit')){
            this.props.tempChangedProduct(pdfType, undefined);
        }
        else {
            this.props.tempNewProduct(pdfType, undefined);
        }
    };

    removeRecipe = (recipe) => {
        this.setState({
            recipes: this.state.recipes
              .filter(rec =>
              rec.name !== recipe.name)
        });
    };

    render() {
        const isEdit = this.props.router.location.pathname.includes('edit');
        return (
            <ProductsFormComponent
                removeAttachment={this.removeAttachment}
                handleImageInput={this.handleImageInput}
                handlePdfInput={this.handlePdfInput}
                handleTextInputChange={this.handleTextInputChange}
                allCategories={this.props.allCategories}
                categoriesResultsToDisplay={this.props.categories.resultsToDisplay}
                handleDelete={this.handleDelete}
                productsStore={this.props.products}
                changeStoreSettings={this.props.changeStoreSettings}
                showEditing={this.props.products.showEditing}
                selectedProduct={this.props.products.showEditingProduct}
                showProduct={this.showProduct}
                isNew={!isEdit}
                categories={this.getCategoryArray()}
                selectedMenuItem={isEdit?this.props.products.changedProduct.cid:this.props.products.newProduct.cid}
                product={isEdit?this.props.products.changedProduct:this.props.products.newProduct }
                handleInputChange={this.handleProductInputChange}
                handleSubmit={this.handleProductSubmit}
                brands={this.props.brands}
                relatedProductsSelected={this.props.relatedProductsSelected}
                setRelatedProducts={this.props.setRelatedProducts}
                relatedProductsEdit={isEdit ? fillInNames(this.props.relatedProductsSelectedEdit, this.props.products) : null}
                setRelatedProductsEdit={this.props.setRelatedProductsEdit}
                onAddRecipe={this.addRecipe}
                recipes={this.state.recipes}
                errorMessage={this.state.errorMessage}
                uploading={this.state.uploading}
                removeRecipe={this.removeRecipe}
                labels={this.props.labels}
                setProductLabel={this.props.tempNewProductAddProductLabel}
                editProductLabel={this.props.editProductLabel}
                removePdf={this.removePdf}
                operatorGroups={this.props.operatorGroups}
                setOperatorGroups={this.props.setOperatorGroups}
                editOperatorGroups={this.props.editOperatorGroups}
            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        products: parseProducts(state.products),
        fetchingProduct: state.products.get('fetchingProduct'),
        categories: parseCategories(state.categories),
        allCategories: parseCategories(state.categories).all,
        login: parseLogin(state.login),
        router: state.router,
        brands: parseBrands(state.brands.get('brands')),
        relatedProductsSelected: parseRelatedProducts(state.relatedProducts.get('all')),
        relatedProductsSelectedEdit: parseRelatedProducts(state.relatedProducts.get('toEdit')),
        labels: parseLabels(state.productLabels.get('labels')),
        operatorGroups: parseOperatorGroups(state.operatorGroups.get('operatorGroups')),
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        tempChangedProduct: (productId, productVal) => {
            dispatch(editChangedProduct(productId, productVal))
        },
        tempNewProduct: (productId, productVal) => {
            dispatch(editNewProduct(productId, productVal))
        },
        editProduct: (data, token) => {
            dispatch(editingProduct(data, token));
        },
        addProduct: (data, productBrand) => {
            dispatch(addingProduct(data, productBrand));
        },
        getProducts: () => {
            dispatch(gettingAllProducts());
        },
        getAllCategories: (brandId, token) => {
            dispatch(toGetCategories(brandId, token))
        },
        showEditProductForm: (product) => {
            dispatch(showingEditProductForm(product));
        },
        changeStoreSettings: (key, value) => {
            dispatch(changeProductFormSettings(key, value))
        },
        deleteProduct: (pid,token) => {
            dispatch(deletingProduct(pid, token));
        },
        getProductBydId: (productId, token) => {
            dispatch(getProductBydId(productId, token))
        },
        push: (url) => {
            dispatch(push(url))
        },
        goBack: () => {
            dispatch(goBack())
        },
        getBrands: (payload) => {
            dispatch(getBrands(payload))
        },
        setRelatedProducts: (payload) => {
            dispatch(setRelatedProducts(payload))
        },
        setRelatedProductsEdit: (payload) => {
            dispatch(setRelatedProductsEdit(payload))
        },
        clearRelatedProducts: (payload) => {
            dispatch(clearRelatedProducts(payload))
        },
        getProductsLabels: (payload) => {
            dispatch(getProductsLabels(payload))
        },
        tempNewProductAddProductLabel: (payload) => {
            dispatch(tempNewProductAddProductLabel(payload))
        },
        editProductLabel: (payload) => {
            dispatch(editProductLabel(payload))
        },
        setOperatorGroups: (payload) => {
            dispatch(setOperatorGroups(payload))
        },
        editOperatorGroups: (payload) => {
            dispatch(editOperatorGroups(payload))
        },
        clearProduct: () => {
            dispatch(clearProduct())
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductFormHOC);




// WEBPACK FOOTER //
// ./src/containers/Products/productFormHOC.js